import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  ButtonGroup,
  ButtonGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeading,
} from "@boozallen-uip/uswds-react-core";

export default function AppModal({
  id,
  isOpen,
  onStateChanged,
  title,
  body,
  primaryActionText,
  onPrimaryAction,
  secondaryActionText,
  onSecondaryAction,
  forceAction,
}) {
  return (
    <Modal
      id={id}
      labelledBy={`${id}-heading`}
      describedBy={`${id}-body`}
      isOpen={isOpen}
      onStateChanged={onStateChanged}
      forceAction={forceAction}
    >
      <ModalHeading id={`${id}-heading`}>{title}</ModalHeading>

      <ModalBody id={`${id}-body`}>{body}</ModalBody>

      <ModalFooter>
        <ButtonGroup>
          <ButtonGroupItem>
            <Button onClick={onPrimaryAction}>{primaryActionText}</Button>
          </ButtonGroupItem>

          {secondaryActionText ? (
            <ButtonGroupItem>
              <Button
                className="padding-105 text-center"
                unstyled
                onClick={onSecondaryAction}
              >
                {secondaryActionText}
              </Button>
            </ButtonGroupItem>
          ) : null}
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
}

AppModal.propTypes = {
  id: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onStateChanged: PropTypes.func,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  primaryActionText: PropTypes.string.isRequired,
  onPrimaryAction: PropTypes.func.isRequired,
  secondaryActionText: PropTypes.string,
  onSecondaryAction: PropTypes.func,
  forceAction: PropTypes.bool,
};

AppModal.defaultProps = {
  onStateChanged: undefined,
  secondaryActionText: null,
  onSecondaryAction: undefined,
  forceAction: false,
};
